(function($) {
$('#toggle').click(function() {
   $(this).toggleClass('active');
   $('#overlay').toggleClass('open');
  });


// Lightbox Gallery

$(document).on('click', '[data-toggle="lightbox"]', function(event) {
	event.preventDefault();
	$(this).ekkoLightbox({
		alwaysShowClose: true
	});
});

//Aos Animation

AOS.init({
	offset: 200,
	duration: 800,
	disable: 'mobile',
	easing: 'ease-in-quad',
	delay: 100,
  });

// Hamburger Toggle

$(document).ready(function () {
	$('.first-button').on('click', function () {
  
	  $('.animated-icon1').toggleClass('open');
	});
	
  });

  // DropDown Menu
  $('.dropdown').on('show.bs.dropdown', function(e){
	$(this).find('.dropdown-menu').first().stop(true, true).slideDown(300);
  });
  
  $('.dropdown').on('hide.bs.dropdown', function(e){
	$(this).find('.dropdown-menu').first().stop(true, true).slideUp(300);
  });



  // on Scroll logo resize
  /*  Header onscroll background-color */
$(function() {
	$(window).on("scroll", function() {
		if ($(window).width() > 320) {
		 if($(window).scrollTop() > 50) {
			 $(".navbar").addClass("fixed-top-zero");
			 $(".navbar-top").addClass("none-navbar");
			 $(".navbar-brand-img").addClass("logo-resize");
			// $(".navbar-brand-img").addClass("p-3");
		 } else {
			 //remove the background property so it comes transparent again (defined in your css)
			$(".navbar").removeClass("fixed-top-zero");
		   $(".navbar-top").removeClass("none-navbar");
		   $(".navbar-brand-img").removeClass("logo-resize");
		   $(".navbar-brand-img").removeClass("p-3");
		}
	}
	});});
	
  // Slide menu
	(function () {
		$('.hamburger-menu').on('click', function() {
			$('.bar').toggleClass('animate');
		var mobileNav = $('.mobile-nav');
		mobileNav.toggleClass('hide show');
		})
	})();

	/*** Single Gallery Tab **/
$(document).ready(function()
{
	$('a[title=\'View Gallery\']').click(function(e)
	{
		e.preventDefault();
		$('a[data-fancybox="gallery"]')[0].click();
	});
});

})(jQuery);

//Open Nav Search
   function openNav() {
	document.getElementById("myNav").style.height = "100%";
  }
  
  function closeNav() {
	document.getElementById("myNav").style.height = "0%";
  }

  //Open Nav Menu
  function openNavmenu() {
	document.getElementById("myMenu").style.height = "100%";
  }
  
  function closeNavmenu() {
	document.getElementById("myMenu").style.height = "0%";
  }

